<template>
  <div class="container">
    <Loader v-if="isLoading" />
    <b-row>
      <b-col md="12">
        <h1 class="mb-3">Typeform Testler</h1>
      </b-col>
      <b-col md="9" class="mb-3">
        <b-btn
          variant="success"
          @click.stop="
            typeformModalType = 'create';
            isTypeformModalShown = true;
          "
        >
          Yeni Typeform Ekle
        </b-btn>
      </b-col>
      <b-col md="3" class="text-right">
        <b-form-input v-model="table.filter" placeholder="Arama" />
      </b-col>
    </b-row>

    <b-table
      class="table-row-cursor"
      show-empty
      outlined
      striped
      hover
      stacked="md"
      empty-text="Gösterilecek kayıt bulunmamaktadır"
      :items="typeforms"
      :fields="table.fields"
      :current-page="table.currentPage"
      :per-page="table.perPage"
      :sort-by.sync="table.sortBy"
      :sort-desc.sync="table.sortDesc"
      :filter="table.filter"
      @row-clicked="openObjectDetailModal"
      @filtered="
        table.totalRows = $event.length;
        table.currentPage = 1;
      "
    >
      <template #cell(actions)="row">
        <b-button
          size="sm"
          class="mr-1 bg-dark"
          variant="dark"
          @click.stop="openTypeformModal(row.item, 'update')"
        >
          Düzenle
        </b-button>
        <b-button
          size="sm"
          class="mr-1 bg-danger"
          variant="danger"
          @click.stop="openRemoveConfirmationDialog(row.item)"
        >
          Sil
        </b-button>
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="table.currentPage"
          :total-rows="table.totalRows"
          :per-page="table.perPage"
          hide-goto-end-buttons
          class="my-0"
        />
      </b-col>
    </b-row>

    <ObjectDetailModal
      v-if="selectedTypeform.name"
      v-model="isObjectDetailModalShown"
      :object="selectedTypeform"
      :title="selectedTypeform.name"
    />

    <TypeformModal
      v-model="isTypeformModalShown"
      :data="selectedTypeform"
      :type="typeformModalType"
    />

    <b-modal
      v-if="selectedTypeform.name"
      v-model="isTypeformRemoveModalShown"
      ok-title="Sil"
      cancel-title="Vazgeç"
      :title="selectedTypeform.name"
      @ok="removeTypeform"
    >
      {{ selectedTypeform.name }} dilini silmek istediğinizden emin misiniz?
    </b-modal>
  </div>
</template>
<script>
import Loader from '@/components/Loader';
import ObjectDetailModal from '@/container/admin/ObjectDetailModal';
import TypeformModal from '@/container/admin/typeform/TypeformModal';

import { API } from '@/services/';
import { API_GET_TYPEFORMS, API_REMOVE_TYPEFORM_BY_ID } from '@/helpers/config';

export default {
  components: {
    Loader,
    ObjectDetailModal,
    TypeformModal,
  },
  data: () => ({
    isLoading: true,
    typeforms: [],
    selectedTypeform: {},
    isObjectDetailModalShown: false,
    isTypeformModalShown: false,
    isTypeformRemoveModalShown: false,
    typeformModalType: 'create',
    table: {
      fields: [
        {
          key: 'name',
          label: 'Typeform',
          sortable: true,
          sortDirection: 'desc',
        },
        {
          key: 'id',
          label: 'Typeform ID',
          sortable: true,
          sortDirection: 'desc',
        },
        {
          key: 'actions',
          label: 'İşlem',
          class: 'text-right',
        },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: null,
      sortBy: null,
      sortDesc: false,
      filter: null,
    },
  }),
  created() {
    this.getTypeforms();
  },
  methods: {
    openObjectDetailModal(typeform) {
      this.selectedTypeform = typeform;
      this.isObjectDetailModalShown = true;
    },
    openTypeformModal(typeform, type) {
      this.selectedTypeform = typeform;
      this.typeformModalType = type;
      this.isTypeformModalShown = true;
    },
    openRemoveConfirmationDialog(typeform) {
      this.selectedTypeform = typeform;
      this.isTypeformRemoveModalShown = true;
    },
    getTypeforms() {
      API.get(API_GET_TYPEFORMS).then((response) => {
        this.typeforms = response.data;
        this.isLoading = false;
      });
    },
    removeTypeform() {
      API.delete(API_REMOVE_TYPEFORM_BY_ID + this.selectedTypeform.id)
        .then((response) => {
          this.$snotify.success(response.data.message);
          this.isLoading = false;
        })
        .catch((error) => {
          this.$snotify.error(error.response.data.message);
          this.isLoading = false;
        });
    },
  },
};
</script>
<style>
</style>
